

import React, { Component } from "react";
import {service} from './service'

class Login extends Component {
    constructor() {
        super();
        this.state = {
        username: '',
        password: '',
        };
        this.handleInput = this.handleInput.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
    }

    componentDidMount() {
    }

    handleInput(field, e) {

    this.setState({ [field]: e.target.value })

    }

    handleLogin(){
        const {username, password} = this.state
        service.login(username, password).then(({ ID }) => {

            if(ID){
                alert("SDfdsf")
            }
        })

    }
    
    render() {
        return (
            <nav className="my-4">
                <div className="container">
                    <div className="text-center container">
                        <form className="form-signin col-md-6">
                        <img className="mb-4" src="https://getbootstrap.com/docs/4.0/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"></img>
                        <h1 className="h3 mb-3 font-weight-normal">Гуйжийн битий логин хий</h1>

                        <input 
                            type="email" 
                            id="inputEmail" 
                            className="form-control" 
                            onChange={(e) => this.handleInput('username', e)}
                        ></input>

                        <label className="sr-only">Password</label>
                        <input 
                            type="password" 
                            id="inputPassword" 
                            className="form-control" 
                            required=""
                            onChange={(e) => this.handleInput('password', e)}
                        ></input>
                        <div className="checkbox mb-3">
                            <label>
                            <input type="checkbox" value="remember-me"></input> Хадгалхуу гөхшөө
                            </label>
                        </div>

                        <button className="btn btn-lg btn-primary btn-block" type="submit" onClick={this.handleLogin}>Sign in</button>
                        <p className="mt-5 mb-3 text-muted">© Мангаа</p>
                        </form>
                    </div>
                </div>
            </nav>
        );
    }
}


export default Login;